import { render, staticRenderFns } from "./TransportNews.vue?vue&type=template&id=6377172a&scoped=true&"
import script from "./TransportNews.vue?vue&type=script&lang=js&"
export * from "./TransportNews.vue?vue&type=script&lang=js&"
import style0 from "./TransportNews.vue?vue&type=style&index=0&id=6377172a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6377172a",
  null
  
)

export default component.exports